<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogDetail" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Fiche de Validation d'une demande de maintenance</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card color="" class="mb-5" flat >
                                    <v-layout wrap>
                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations generales sur la demande
                                            </v-alert>
                                            <v-card flat>
                                                <v-layout wrap>
                                                    <v-card-text>
                                                        <v-flex xs12>
                                                            <v-flex xs12 class="text-xs-left"> <!--HAUT-->
                                                                <v-layout row>
                                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>Identifiant de la demande</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                DMD-{{demandeDetail.idDemande}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Batiment</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.batiment}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Salle</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.salle}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Priorite</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                   {{demandeDetail.libPriorite}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>



                                                                        <v-layout row>
                                                                            <v-flex xs6>Date de la demande</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.date}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Nom du demandeur</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                               {{demandeDetail.nomDemandeur}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-divider class="mb-3"></v-divider>


                                                                        <v-layout row>
                                                                            <v-flex  v-if="demandeDetail.imageDmd1" xs3 class="mr-3">
                                                                                <a :href="demandeDetail.imageDmd1"  target=_blank>
                                                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="demandeDetail.imageDmd1"></v-avatar>
                                                                                </a>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </v-flex>

                                                                    <v-flex xs6 class="text-xs-left"> <!--BAS-->
                                                                        <v-layout row>
                                                                            <v-flex xs6>Status</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.libStatut}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row  >
                                                                            <v-flex xs6>Etat</v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                {{demandeDetail.libEtatDmd}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Enregistré par </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                 {{demandeDetail.userRepresentant}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                         <v-layout row>
                                                                            <v-flex xs6>Domaine d'activité </v-flex>
                                                                            <v-flex xs6 class="text-xs-right title">
                                                                                 {{demandeDetail.domaine}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                          <v-layout row>
                                                                               <v-flex xs2>Description </v-flex>
                                                                               <v-flex xs10>
                                                                                    <el-form    class="demo-ruleForm">
                                                                                        <el-form-item   label="" style="width:100%" >
                                                                                            <el-input  disabled  type="textarea" v-model="demandeDetail.commentaire"></el-input>
                                                                                        </el-form-item>
                                                                                    </el-form >
                                                                                </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                    </v-flex>
                                                                </v-layout>


                                                            </v-flex>
                                                        </v-flex>
                                                    </v-card-text>
                                                </v-layout>
                                            </v-card>
                                        </v-flex>

                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Visites et constats
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                     <v-layout row>
                                                        <v-flex xs3>Constat effectué par :</v-flex>
                                                        <v-flex xs6 class="text-xs-left title">
                                                            {{demandeDetail.nomTech}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>

                                                    <el-form disabled id="formRapport" style="width:100%"   :model="formRapport"  >
                            <v-layout row >
                                <v-flex xs6 >
                                   <v-layout row>
                                        <v-flex v-if="demandeDetail.imageConst1" xs3 class="mr-3">
                                            <a :href="demandeDetail.imageConst1"  target=_blank>
                                                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="demandeDetail.imageConst1" ></v-avatar>
                                            </a>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                 <v-flex xs6 >
                                         <el-form-item style="width:100%" label="Rapport de constat" >
                                        <el-input
                                        style="width:100%"
                                           disabled
                                            type="textarea"
                                            :rows="6"
                                            placeholder="Rapport sur le constat"
                                            v-model="formRapport.rapport">
                                        </el-input>
                                         </el-form-item >

                                </v-flex>
                            </v-layout>
                            </el-form>
                                      <v-layout wrap>
                                          <v-flex xs12>
                                            <v-card>
                                            <v-layout row>
                                                <el-table :data="tableProduit" style="width: 100%">
                                                    <el-table-column prop="designation" label="Designation" sortable> </el-table-column>
                                                    <el-table-column prop="quantite" label="Quantite"> </el-table-column>
                                                </el-table>
                                            </v-layout>
                                            <br>
                                        </v-card>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-card-text>
                                            </v-card>
                                        </v-flex>

                                         <v-flex xs12>
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Première Validation
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                           <v-layout row>
                                                                <el-table :data="demandeDetail.nomValidateurs" style="width: 100%">
                                                                    <el-table-column prop="nom" label="Nom du validateur" sortable> </el-table-column>
                                                                    <el-table-column prop="date" label="Date"> </el-table-column>
                                                                    <el-table-column prop="valider" label="Decision"></el-table-column>
                                                                </el-table>
                                                            </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
            <v-tooltip top>
                    <v-btn  class="mb-5" style="margin-right: 100px"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="red"
                           @click="dialogConfirmRefus = true"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                    <span>Refuser la demande</span>
                </v-tooltip>



                <v-tooltip top>
                    <v-btn class="mb-5 ml-5"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="green"
                           @click="dialogConfirm = true"
                    >
                        <v-icon>done</v-icon>
                    </v-btn>
                    <span>Valider la demande</span>
                </v-tooltip>
        </v-dialog>

         <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation du devis pour une demande de maintenance</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous Refuser ce devis ?"
                        :closable="false"
                        show-icon
                        type="error">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">DEMANDE</p>
                    <p class="black--text .font-weight-regular subheading" >DMD-{{demandeDetail.idDemande}}</p>
                </v-flex>
                <v-flex xs12>
                    <el-form  id="formRefus" :rules="ruleFormRefus" ref="refFormRefust"  label-position="top" :inline="true" :model="formRefus" class="demo-form-inline">
                     <v-flex xs12 >
                        <el-form-item style="width:100%" label="Commentaire" prop="rapportRefus" >
                            <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Pourquoi voulez-vous refuser ?" v-model="formRefus.rapport"></el-input>
                        </el-form-item >
                    </v-flex>
                    </el-form>
                </v-flex>

            </v-layout>

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirmRefus = false">Annuler</v-btn>
                <v-btn color="red darken-1" dark @click.native="SubmitRefusDevis()">Refuser</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>

         <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation du devis pour une demande de maintenance</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous valider le devis ?"
                        :closable="false"
                        show-icon
                        type="success">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">DEMANDE</p>
                    <p class="black--text .font-weight-regular subheading" >DMD-{{demandeDetail.idDemande}}</p>
                </v-flex>
            </v-layout>

                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirm = false">Annuler</v-btn>
                <v-btn color="green darken-1" dark  @click.native="SubmitValideDevis()">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "ModalValidationDmd",
        props:["show","demandeDetail"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit:[],
            totalTTC:0,
            formRapport:{},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            dialogConfirm: false,
            formRefus:{},
             ruleFormRefus: {
                rapportRefus: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            },

         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDetail = newValue
               if(newValue == true){
                   this.loadDevisConstat();

               }
            }
        },

        methods: {
             successNotif(mess = ""){
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
            },
             closeDialog(){
                this.$emit('close',this.demandeDetail.idDemande,"maintenance")
            },
             loadDevisConstat ()
            {
            this.loading = true
            let url = this.domaine + 'demande_maintenance/devis/constat/'+this.demandeDetail.idDemande
            this.$http.get(url).then(response => {

                this.tableProduit = response.body.tableProduit
                this.formRapport.rapport = response.body.rapport
                this.totalTTC = response.body.total
                 this.loading = false
            },errResp=>{
                 this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la table des produits")
            })
            },
             handleRemove(file, fileList) {                
            },
            handleSuccess(response, file, fileList){
                    this.fileList.push(file)
            },
            handlePictureCardPreview(file, fileList) {                 
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            imprimerDetail(){


                let  url = this.domaine+"demande_maintenance/imprimerPDF/demande/"+this.user.id+"/"+this.demandeDetail.idDemande
                window.open(url)
            },
             SubmitValideDevis(){
                this.loading = true
                let url = this.domaine + 'demande_maintenance/devis/validation2'
                let data = new FormData()
                data.append("idDemande",  this.demandeDetail.idDemande)
                data.append("idUser",  this.user.id)
                this.$http.post(url,data).then(response => {
                this.loading = false
                this.successNotif(response.body.message)
                this.dialogConfirm = false
                this.closeDialog();

            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors de la validation du devis")
            })
            },
             SubmitRefusDevis(){
                this.loading = true
                let url = this.domaine + 'demande_maintenance/devis/refuser'
                let data = new FormData()
                data.append("idDemande",  this.demandeDetail.idDemande)
                data.append("idUser",  this.user.id)
                data.append("rapport",  this.formRefus.rapport)

                this.$http.post(url,data).then(response => {
                this.loading = false
                this.successNotif(response.body.message)
                 this.dialogConfirmRefus = false
                this.closeDialog();

            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors du refus du devis")
            })
            }
        },
        mounted(){

        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationDmd.vue